import styles from "./bar-chart.module.scss";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { AppContext } from "helpers/context";
import Chart from "components/chart/chart";
import LegendIconButton from "./data/legend-icon-button";
import NoDataText from "../nodata-text";
import { RightPanel } from "helpers/constants";

interface Props {
    tableData: any;
    activeLegend: any;
    noAnalysisLocationRef?: any;
    noData: any;
    chartHeight: any;
    chartOption: any;
    analysedLegends: any;
    handleLegendClick: (index: number, layerId: string) => void;
    distanceUnit?: "m" | "km";
}

function BarChart({
    tableData,
    activeLegend,
    noAnalysisLocationRef = { current: [] },
    chartHeight,
    noData,
    chartOption,
    analysedLegends,
    handleLegendClick,
    distanceUnit = "km"
}: Readonly<Props>) {
    const [t] = useTranslation();
    const [context, dispatch] = useContext(AppContext);

    const handleChartTitle = () => {
        if (context.rightPanel === RightPanel.Line || context.rightPanel === RightPanel.Polygon) {
            return distanceUnit === "m" ? t("drawShape.length(m)") : t("drawShape.length(km)")
        } else {
            const analysedLocationSet =
                context.currentMultipleLocationsAnalysed ?? context.currentMultipleLocations;
            const unit = analysedLocationSet?.aggregationUnit ?? "numberOfLocations";

            let title = ""
            if (unit !== "numberOfLocations" && unit !== "numberOfRisks") {
                title = analysedLocationSet?.currency ? `(${analysedLocationSet.currency})` : ""
            }
            return t(`locations.${unit}`) + title
        }
    }

    return <div className={styles.barChart}>
        {(tableData.length > 0 || noAnalysisLocationRef.current.length > 0) && <div
            className={styles.chart}
            style={{ height: chartHeight * 63 + "px" }}
        >
            <div className={styles.legendIcon}>
                <LegendIconButton
                    tableData={tableData}
                    activeLegend={activeLegend}
                    analysedLegends={analysedLegends}
                    handleLegendClick={handleLegendClick}
                />
            </div>
            <Chart option={chartOption} />
        </div>}
        <div
            style={{
                marginRight: "10px",
                marginBottom: "10px",
                textAlign: "center",
                fontSize: "12px",
            }}
        >
            {handleChartTitle()}
        </div>

        {noData.length > 0 && <NoDataText noData={noData} />}
    </div>
}

export default BarChart

